import { render } from "./Old_D1_Sales.vue?vue&type=template&id=1a9cac17"
import script from "./Old_D1_Sales.vue?vue&type=script&lang=js"
export * from "./Old_D1_Sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Old_D1_Sales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a9cac17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a9cac17', __exports__)) {
    api.reload('1a9cac17', __exports__)
  }
  
  module.hot.accept("./Old_D1_Sales.vue?vue&type=template&id=1a9cac17", () => {
    api.rerender('1a9cac17', render)
  })

}


export default __exports__